// extracted by mini-css-extract-plugin
export var blue = "_c-f";
export var brand = "_c-b";
export var darkGrey = "_c-e";
export var disabled = "_c-4";
export var disabledSubtle = "_c-5";
export var error = "_c-6";
export var green = "_c-g";
export var grey = "_c-d";
export var icon = "_c-0";
export var inherit = "_c-a";
export var lightGrey = "_c-c";
export var orange = "_c-i";
export var pink = "_c-k";
export var primary = "_c-1";
export var purple = "_c-l";
export var red = "_c-j";
export var secondary = "_c-2";
export var success = "_c-9";
export var tertiary = "_c-3";
export var warning = "_c-7";
export var warningSecondary = "_c-8";
export var white = "_c-m";
export var yellow = "_c-h";